//---------------------------------------------------------------//
// Tabs-to-Accordions Features
//---------------------------------------------------------------//

// These start as Tabs panels on desktop and convert to Accordions at mobile
// Wrap it in the doc ready
// Inspired from: https://codepen.io/anon/pen/MPWwrd

let accordionOpen = false;
let tabOpen = false;

// Function to determine what should happen to the first tab content and triggers.
// On mobile, the first tab content will be hidden initially under the accordion trigger.
// On desktop, the first tab content will need to shown.
function toggleTabContent() {
  const thisWidth = window.innerWidth;

  if (thisWidth < 800 && accordionOpen == false) {
    $('.tab_content').hide();
    $('.tab_drawer_heading').removeClass('d_active');
    accordionOpen = true;
  } else if (thisWidth < 800 && accordionOpen) {
    return false;
    // accordionOpen = true;
  } else if (thisWidth >= 800 && tabOpen == false) {
    // this is triggered when page load occurs above 800px breakpoint
    $('.tabs li').removeClass('active');
    $('.tab_content').hide();

    //feature 22 check for query param
    var dc_field = 'pro';
    var dc_url = window.location.href;
    if (dc_url.indexOf('?' + dc_field + '=') != -1) {
      //someone clicked pro show second tab
      // $('.tab_content:nth-child(2)').show();
      $('#tab2').show();
      $('.tabs li:nth-child(2)').addClass('active');
    } else {
      $('.tab_content').first().show();
      $('.tabs li:first-child').addClass('active');
    }

    tabOpen = true;
  } else if (thisWidth >= 800 && tabOpen == true) {
    // this is triggered when page load occurs above 800px breakpoint, then size down to accordions, then size back up to tabs
    $('.tabs li').removeClass('active');
    $('.tab_content').hide();
    $('.tab_content').first().show();
    $('.tabs li:first-child').addClass('active');
    return false;
    //tabOpen = true;
  } else {
    return false;
  }
}
toggleTabContent();

$(window).resize(toggleTabContent);

// if in tab mode -- desktop
$('ul.tabs li').click(function () {
  $('.tab_content').hide();
  var activeTab = $(this).attr('rel');
  $('#' + activeTab).fadeIn();

  $('ul.tabs li').removeClass('active');
  $(this).addClass('active');

  $('.tab_drawer_heading').removeClass('d_active');
  $('.tab_drawer_heading[rel^=' + activeTab + ']').addClass('d_active');
});

// if in drawer (accordion) mode -- mobile
$('.tab_drawer_heading').click(function () {
  var d_activeTab = $(this).attr('rel');

  // If user clicks on currently active accordion, then close it.
  if ($(this).hasClass('d_active')) {
    $(this).removeClass('d_active');
    $('#' + d_activeTab).slideUp(400);
    setTimeout(function () {
      $('#' + d_activeTab).removeClass('d_active_content');
    }, 400);
  }
  // Otherwise, user clicked on a different accordion item.
  else {
    // first close all other open accordions
    $('.tab_content').slideUp(400);
    // then open the one user clicked on
    $('#' + d_activeTab)
      .addClass('d_active_content')
      .slideToggle(500);
    // swap around some classes
    $('.tab_drawer_heading').removeClass('d_active');
    $(this).addClass('d_active');
    $('ul.tabs li').removeClass('active');
    $('ul.tabs li[rel^=' + d_activeTab + ']').addClass('active');
  }
});

// Extra class 'tab_last' to add border to right side of last tab
$('ul.tabs li').last().addClass('tab-last');
